import React, { useState, useEffect } from 'react';
import { FormViewContent } from 'components/FormViewContent';
import { ReactSelect } from 'components/FormHelpers/FormInputs';
import _ from 'lodash';
import PropTypes from 'prop-types';

const PSRCheckValue = ({
  handleChange,
  checkValueOptions,
  value,
  isDisabled
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (!_.isEmpty(checkValueOptions)) {
      setSuggestions(checkValueOptions);
    } else {
      setSuggestions([]);
    }
  }, [setSuggestions, checkValueOptions]);


  useEffect(() => {
    if (!_.isEmpty(checkValueOptions)) {
      setSelected(_.filter(checkValueOptions,
        (item) => item.value === value));
    } else {
      setSelected(null);
    }
  }, [setSelected, checkValueOptions, value]);

  const handleInputChange = val => {
    const lcVal = val && val.toLowerCase();
    setSuggestions(_.filter(checkValueOptions,
      (item) => item.label.toLowerCase().includes(lcVal)));
  };
  return (
    <FormViewContent
      primaryText="Check Value"
      secondaryText={(
        <ReactSelect
          title="Check Value Selector"
          name="code"
          onChange={handleChange}
          value={selected}
          onInputChange={handleInputChange}
          options={suggestions}
          disabled={isDisabled}
        />
      )}
    />
  );
};

PSRCheckValue.propTypes = {
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  checkValueOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })),
  isDisabled: PropTypes.bool.isRequired
};

PSRCheckValue.defaultProps = {
  checkValueOptions: []
};

export default PSRCheckValue;
